import { createSelector } from 'reselect';
import CarrierNestingDetailsColumns from '../../containers/CarrierNestingDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_NESTING_DETAILS_801.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_NESTING_DETAILS_801.isLoading;

export const getData =
  ReportDefinitions.CARDIT_NESTING_DETAILS_801.getDataFunction();

export const getColumns =
  createSelector(getData, CarrierNestingDetailsColumns);
